import { render, staticRenderFns } from "./ListPageLayout.vue?vue&type=template&id=1510c3cc&scoped=true"
import script from "./ListPageLayout.vue?vue&type=script&lang=js"
export * from "./ListPageLayout.vue?vue&type=script&lang=js"
import style0 from "./ListPageLayout.vue?vue&type=style&index=0&id=1510c3cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1510c3cc",
  null
  
)

export default component.exports